import { render } from "./BlogZircVenLongevity.vue?vue&type=template&id=3729ad5b"
import script from "./BlogZircVenLongevity.vue?vue&type=script&lang=js"
export * from "./BlogZircVenLongevity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__